// Display mirror of backend/src/lib/bureauChangeRequests.ts: which bureau
// details change only through a request the platform owner decides.

export const BUREAU_CHANGE_FIELDS = ["name", "accreditationBody", "accreditation", "country"] as const;
export type BureauChangeField = (typeof BUREAU_CHANGE_FIELDS)[number];
export type BureauChangeValues = Partial<Record<BureauChangeField, string | null>>;
export type BureauChangeStatus = "pending" | "approved" | "declined" | "withdrawn";

export const BUREAU_CHANGE_FIELD_LABELS: Record<BureauChangeField, string> = {
  name: "Name",
  accreditationBody: "Accreditation body",
  accreditation: "Accreditation",
  country: "Country",
};

export const BUREAU_CHANGE_STATUS_LABELS: Record<BureauChangeStatus, string> = {
  pending: "Awaiting review",
  approved: "Approved",
  declined: "Declined",
  withdrawn: "Withdrawn",
};

export interface BureauChangeRequest {
  id: string;
  bureauId: string;
  requested: BureauChangeValues;
  previous: BureauChangeValues;
  reason: string;
  status: BureauChangeStatus;
  reviewedAt: string | null;
  reviewNote: string | null;
  createdAt: string;
  requestedBy: { id: string; displayName: string; email: string } | null;
  reviewedBy: { id: string; displayName: string } | null;
}

export type BureauDetails = Record<BureauChangeField, string | null> & { id: string };

export function fmtChangeDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}
